var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomelog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205.648,
    height: 56.002,
    viewBox: "0 0 205.648 56.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63615",
    "data-name": "Group 63615",
    transform: "translate(-140 -44.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-1140.779,1806a6.235,6.235,0,0,1-6.221-6.235v-43.532a6.235,6.235,0,0,1,6.221-6.235h22.546a6.235,6.235,0,0,1,6.221,6.235v43.532a6.235,6.235,0,0,1-6.221,6.235Zm22.546-1.782a4.456,4.456,0,0,0,4.443-4.453v-21.1h-7.893l-.754-1.331h8.647v-21.1a4.456,4.456,0,0,0-4.443-4.453h-7.029v1.327h-8.491v-1.327h-7.025a4.456,4.456,0,0,0-4.443,4.453v21.1h5.095l.668.67-.657.661h-5.105v21.1a4.456,4.456,0,0,0,4.443,4.453h7.025v-1.336h8.491v1.336Zm-13.06-2.912a29.751,29.751,0,0,1,7.55-13.738,3.9,3.9,0,0,0,1.1,1.424,28.109,28.109,0,0,0-6.825,12.313h-1.826Zm8.364-15.316a2.705,2.705,0,0,1,2.7-2.7,2.7,2.7,0,0,1,2.7,2.7,2.706,2.706,0,0,1-2.7,2.708A2.709,2.709,0,0,1-1122.929,1785.992Zm1.777,0a.927.927,0,0,0,.924.927.921.921,0,0,0,.92-.927.92.92,0,0,0-.92-.922A.926.926,0,0,0-1121.152,1785.992Zm-1.684-2.831-9.959-17.864a3.672,3.672,0,0,0,1.556-.869l9.959,17.86a3.975,3.975,0,0,0-1.556.873h0Zm-13.615-3.906-1.238,1.24-1.258-1.26,1.239-1.24-1.239-1.24,1.258-1.26,1.238,1.241,1.238-1.241,1.256,1.26-1.237,1.24,1.237,1.24-1.256,1.26Zm9.4-.592h-5.735l-.661-.661.67-.67h4.976l.75,1.33h0Zm-9.358-16.924a2.664,2.664,0,0,1,2.658-2.664,2.664,2.664,0,0,1,2.658,2.664,2.664,2.664,0,0,1-2.658,2.664A2.664,2.664,0,0,1-1136.412,1761.739Zm1.7,0a.961.961,0,0,0,.959.961.961.961,0,0,0,.959-.961.961.961,0,0,0-.959-.961A.961.961,0,0,0-1134.712,1761.739Z",
    transform: "translate(1287 -1705.84)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63593",
    "data-name": "Group 63593",
    transform: "translate(190.066 59.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53612",
    "data-name": "Path 53612",
    d: "M14.613,146.873H5.5v4.642h8.939v5.293H5.5v8.839H0V141.58H14.613v5.294Z",
    transform: "translate(0 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53613",
    "data-name": "Path 53613",
    d: "M38.382,165.648l-1.289-3.782H27.83l-1.2,3.782H20.61l8.18-24.068H35.8L44,165.648h-5.63ZM29.5,156.708H35.33l-3.016-8.839-2.822,8.839Z",
    transform: "translate(-5.847 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53614",
    "data-name": "Path 53614",
    d: "M69.569,141.58h5.5v24.068H70.945l-9.283-13.065v13.065h-5.5V141.58h4.126l9.283,13.065V141.58Z",
    transform: "translate(-15.932 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53615",
    "data-name": "Path 53615",
    d: "M94.166,160.354h9.384v5.294H87.11v-4.262l9.212-14.512h-9.04V141.58h16.11v4.233l-9.233,14.541Z",
    transform: "translate(-24.713 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53616",
    "data-name": "Path 53616",
    d: "M123.351,141.58a8.2,8.2,0,0,1,5.981,2.407,8.215,8.215,0,0,1,0,11.69,8.2,8.2,0,0,1-5.981,2.407h-3.61v7.564h-5.5V141.58h9.111Zm0,11.346a2.745,2.745,0,0,0,2.1-.9,3.347,3.347,0,0,0,0-4.4,2.734,2.734,0,0,0-2.1-.9h-3.61v6.189h3.61Z",
    transform: "translate(-32.409 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53617",
    "data-name": "Path 53617",
    d: "M142.56,141.58h5.5v24.068h-5.5V141.58Z",
    transform: "translate(-40.443 -141.086)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53618",
    "data-name": "Path 53618",
    d: "M167.074,165.932a12.054,12.054,0,0,1-8.954-3.6,12.522,12.522,0,0,1,8.954-21.446,12.331,12.331,0,0,1,5.981,1.5,11.308,11.308,0,0,1,4.334,4.076l-4.742,2.751a5.434,5.434,0,0,0-2.271-2.185,7.016,7.016,0,0,0-3.3-.774,6.789,6.789,0,0,0-5.107,1.963,8.03,8.03,0,0,0,0,10.386,6.778,6.778,0,0,0,5.107,1.963,7.018,7.018,0,0,0,3.317-.788,5.338,5.338,0,0,0,2.249-2.163l4.742,2.751a11.059,11.059,0,0,1-4.3,4.076,12.409,12.409,0,0,1-6.017,1.5Z",
    transform: "translate(-43.848 -140.89)",
    fill: "#2b5696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53619",
    "data-name": "Path 53619",
    d: "M209.492,165.648h-6.261l-7.7-11.117v11.117h-5.5V141.58h5.5v10.451l7.356-10.451h6.26l-8.116,11.726,8.46,12.342Z",
    transform: "translate(-53.91 -141.086)",
    fill: "#2b5696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelog);
export default __webpack_public_path__ + "static/media/homelog.a27af45df2ada5e3ce8e1b16ec4c8465.svg";
export { ForwardRef as ReactComponent };